'use client';

import React, { FC } from 'react';

import PartServiceCart from '@/components/part-service-cart/part-service-cart';
import PartSectionContainer from '@/components/UI/part-section-container/part-section-container';
import { IService } from '@/contentful/utils/services';

import styles from './part-services-list.module.scss';

interface IPartServicesList {
  data: {
    lang: string | undefined;
    category: string | undefined;
    title: string | undefined;
    services: IService[];
  };
}

const PartServicesList: FC<IPartServicesList> = ({ data }) => (
  <section className={styles.container}>
    <PartSectionContainer advantage={data.category ?? ''} title={data.title ?? ''}>
      <div className={styles.servicesList}>
        {data.services.map((service) => (
          <PartServiceCart
            service={service}
            lang={data.lang ?? ''}
            key={service.title}
          />
        ))}
      </div>
    </PartSectionContainer>
  </section>
);

export default PartServicesList;
